<template>
  <v-widget
    :title="$t('Role Details')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-form>
        <v-text-field
          v-model="role.name"
          :error-count="role.displayErrors('name').length"
          :error-messages="role.displayErrors('name')"
          :disabled="role.id !== undefined"
          :label="$t('Name')"
          outline
        />

        <v-text-field
          v-model="role.code"
          :error-count="role.displayErrors('code').length"
          :error-messages="role.displayErrors('code')"
          :disabled="role.id !== undefined"
          :label="$t('Code')"
          outline
        />
      </v-form>
    </div>
  </v-widget>
</template>

<script>
export default {
  name: 'RoleDetails',

  props: {
    role: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      menu: false
    }
  }
}
</script>
